import { render, staticRenderFns } from "./FormProtocolSend.vue?vue&type=template&id=24e7a54f&"
import script from "./FormProtocolSend.vue?vue&type=script&lang=js&"
export * from "./FormProtocolSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports